// assets/vh-m2.js — WP-P36 §2: Blog V2 "Magazin". ES5-IIFE, 'use strict', kein Dauer-Timer
// (200-ms-Timer-Test, Skill FALLEN.md #2 / CLAUDE.md §5.8): TOC reagiert auf 'scroll' mit
// requestAnimationFrame-Drosselung, kein setInterval. Budget <= 4 KB Quelle. Muster
// assets/vh-p2.js Abschnitt TOC (data-vh-p2-toc), hier data-vh-m2-toc. Geladen zuletzt aus
// sections/vh-m2-kopf.liquid bzw. sections/vh-m2-blogkopf.liquid, nach vh-c2.js/vh-h2.js.
(function () {
  'use strict';

  var tocs = document.querySelectorAll('[data-vh-m2-toc]');
  if (!tocs.length) { return; }

  // Ab 1000px (Grid-Breakpoint der Seitenspalte, assets/vh-m2.css) gilt das <details> als offene
  // Spalte statt Akkordeon — einmalig beim Laden gesetzt, kein Resize-Listener (Budget-Regel).
  var vhM2Offen = window.matchMedia('(min-width: 1000px)').matches;
  var t;
  for (t = 0; t < tocs.length; t++) { tocs[t].open = vhM2Offen; }

  var ticking = false;
  var updateToc = function () {
    ticking = false;
    for (var i = 0; i < tocs.length; i++) {
      var toc = tocs[i];
      var ids = toc.getAttribute('data-vh-m2-toc').split(',');
      var current = null;
      for (var j = 0; j < ids.length; j++) {
        var el = document.getElementById(ids[j]);
        if (el && el.getBoundingClientRect().top <= 130) { current = ids[j]; }
      }
      var links = toc.querySelectorAll('a[href^="#"]');
      for (var k = 0; k < links.length; k++) {
        var isCurrent = current !== null && links[k].getAttribute('href') === '#' + current;
        if (isCurrent) {
          links[k].classList.add('is-active');
          links[k].setAttribute('aria-current', 'true');
        } else {
          links[k].classList.remove('is-active');
          links[k].removeAttribute('aria-current');
        }
      }
    }
  };
  var onScroll = function () {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(updateToc);
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  updateToc();
}());
